var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',{staticClass:"card"},[_c('div',{staticClass:"title"},[_vm._v(" 【瀑布流商品配置】")]),_c('div',{staticClass:"center"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }